import { db } from '@/vendors/firebase/firebase';

export default {
  async fetchRolePermissions() {
    const snap = await db.collection('rolePermissions').get();
    const map = {};
    snap.forEach((doc) => {
      map[doc.id] = doc.data();
    });
    return map;
  },
};
